<div class="filter-container" [formGroup]="filterForm">

  @if (isLoading) {
    <div class="filter-skeleton">Cargando filtros...</div>
  } @else {

    <mat-form-field appearance="outline" class="filter-select team-filter">
      <mat-label>Equipo Atacante</mat-label>
      <mat-select formControlName="attackingTeam">
        <button
          mat-icon-button
          class="clear-button"
          (click)="clearSelection('attackingTeam', $event)"
          [hidden]="!filterForm.get('attackingTeam')?.value"
          matTooltip="Limpiar selección">
          <mat-icon>clear</mat-icon>
        </button>

        <mat-option [value]="null">- Cualquiera -</mat-option>
        @for (team of teams; track team.id) {
          <mat-option [value]="team.id">{{ team.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-select play-model-filter">
      <mat-label>{{ playModelLabel }}</mat-label>
      <input
        matInput
        formControlName="playModelQuery"
        placeholder="Buscar..."
      />
      <button
        mat-icon-button
        class="clear-button"
        (click)="clearSelection('playModelQuery', $event)"
        [hidden]="!filterForm.get('playModelQuery')?.value"
        matTooltip="Limpiar búsqueda">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>

    @for (key of filteredKeys; track key.clean) {
      <mat-form-field appearance="outline" class="filter-select">
        <mat-label>{{ key.display }}</mat-label>
        <mat-select [formControlName]="key.clean" multiple>
          <button mat-icon-button class="clear-button"
                  (click)="clearSelection(key.clean, $event)"
                  [hidden]="!filterForm.get(key.clean)?.value?.length">
            <mat-icon>clear</mat-icon>
          </button>
          @for (option of playModelOptions[key.display]; track option.id) {
            <mat-option [value]="option.id">{{ option.display }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</div>
